const rankingItems = [
  { rank: 1, title: '星际迷航：新纪元', type: '科幻·4K', hot: '9.6', icon: 'ri-rocket-2-line', change: 'up' },
  { rank: 2, title: '暗夜追踪者', type: '悬疑·蓝光', hot: '9.4', icon: 'ri-search-eye-line', change: 'up' },
  { rank: 3, title: '长安风云录', type: '古装·超清', hot: '9.3', icon: 'ri-ancient-gate-line', change: 'new' },
  { rank: 4, title: '深海危机', type: '动作·4K', hot: '9.1', icon: 'ri-ship-line', change: 'down' },
  { rank: 5, title: '笑傲职场', type: '喜剧·高清', hot: '9.0', icon: 'ri-emotion-laugh-line', change: 'up' },
  { rank: 6, title: '极地求生', type: '纪录·4K', hot: '8.9', icon: 'ri-earth-line', change: 'new' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">热播榜单</h2>
          <p className="mt-3 text-sm text-foreground-500">本周最受欢迎的高清影视内容</p>
        </div>
        <div className="max-w-[720px] mx-auto bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-background-50 transition-colors ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg text-sm font-bold ${
                item.rank === 1 ? 'bg-primary-500 text-white' :
                item.rank === 2 ? 'bg-primary-400 text-white' :
                item.rank === 3 ? 'bg-primary-300 text-white' :
                'bg-secondary-100 text-secondary-600'
              }`}>
                {item.rank}
              </div>
              <div className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg ${
                item.rank <= 3 ? 'bg-accent-100' : 'bg-background-200'
              }`}>
                <i className={`${item.icon} text-lg ${item.rank <= 3 ? 'text-accent-600' : 'text-foreground-500'}`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-foreground-800 truncate">{item.title}</p>
                <p className="text-xs text-foreground-500">{item.type}</p>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-sm font-bold text-primary-600 whitespace-nowrap">{item.hot}</span>
                <i className={`text-xs ${
                  item.change === 'up' ? 'ri-arrow-up-line text-accent-500' :
                  item.change === 'new' ? 'ri-sparkling-line text-primary-500' :
                  'ri-arrow-down-line text-foreground-400'
                }`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}